import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.includes";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { enumData } from '@/decorators';
import AttachmentList from '@/components/attachmentList/index.vue';

var DetailModel = function (_super) {
  __extends(DetailModel, _super);

  function DetailModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    _this.loading = true;
    _this.labelImageOptions = [];
    _this.officer_info = {};
    _this.euroAgentFileTypeEnum = [];
    _this.productExtendColumn = [{
      key: 'file_type_text',
      title: _this.t('文件类型'),
      dataIndex: 'file_type_text',
      width: 120,
      insertKeyAfter: "-1",
      filterEmpty: true
    }];
    _this.detailData = {};
    return _this;
  }

  DetailModel.prototype.handleClose = function () {
    this.$emit('update:visible', false);
  };

  DetailModel.prototype.handleVisibleChange = function (value) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!value) return [3, 4];
            this.officer_info = {};
            this.detailData = {};
            return [4, this.queryComplianceOfficerbyOfficerNo()];

          case 1:
            _a.sent();

            return [4, this.getlabelImageOptions()];

          case 2:
            _a.sent();

            return [4, this.getGPSRDetail()];

          case 3:
            _a.sent();

            return [3, 5];

          case 4:
            this.loading = true;
            _a.label = 5;

          case 5:
            return [2];
        }
      });
    });
  };

  DetailModel.prototype.queryComplianceOfficerbyOfficerNo = function () {
    return __awaiter(this, void 0, Promise, function () {
      var compliance_officer_id, params, _a, code, message, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            compliance_officer_id = this.record.compliance_officer_id;
            if (!compliance_officer_id) return [2];
            params = {
              id: compliance_officer_id
            };
            return [4, this.$api.product.detailComplianceOfficer(params)];

          case 1:
            _a = _b.sent(), code = _a.code, message = _a.message, data = _a.data;

            if (code) {
              return [2, this.$message.error(message)];
            }

            this['officer_info']['compliance_leader_type_text'] = data.compliance_leader_type_text;
            this['officer_info']['compliance_leader_type'] = data.compliance_leader_type;
            this['officer_info']['manufacturer_name'] = data.manufacturer_name;
            this['officer_info']['manufacturer_email'] = data.manufacturer_email;
            this['officer_info']['manufacturer_address'] = data.manufacturer_address;
            this['officer_info']['address'] = data.address;
            this['officer_info']['company'] = data.company;
            this['officer_info']['mail'] = data.mail;
            return [2];
        }
      });
    });
  };

  DetailModel.prototype.getGPSRDetail = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _a, officer_no, product_sku, params, data, error_1;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.record, officer_no = _a.officer_no, product_sku = _a.product_sku;
            if (!product_sku) return [2];
            params = {
              officer_no: officer_no,
              product_sku: product_sku
            };
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            this.loading = true;
            return [4, this.$api.product.getGPSRDetail(params)];

          case 2:
            data = _b.sent().data;
            this.loading = false;
            this.detailData = data;
            return [3, 4];

          case 3:
            error_1 = _b.sent();
            this.loading = false;
            return [3, 4];

          case 4:
            return [2];
        }
      });
    });
  };

  DetailModel.prototype.getlabelImageOptions = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data, code, message;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            this.labelImageOptions = [];
            return [4, this.$api.product.getWarningLabelList({})];

          case 1:
            _a = _b.sent(), data = _a.data, code = _a.code, message = _a.message;

            if (code) {
              return [2, this.$message.error(message)];
            }

            this.labelImageOptions = data;
            return [2];
        }
      });
    });
  };

  DetailModel.prototype.checkSelected = function (item) {
    var gpsr_dto_list = this.detailData.gpsr_dto_list;
    if (!gpsr_dto_list || !gpsr_dto_list.length) return false;
    var warning_label_list = gpsr_dto_list[0].gucang_draw_dto.warning_label_list;
    if (!warning_label_list || !warning_label_list.length) return false;
    return warning_label_list.includes(item.field_code);
  };

  DetailModel.prototype.filterLabelImageOptions = function () {
    var gpsr_dto_list = this.detailData.gpsr_dto_list;

    if (!gpsr_dto_list || !gpsr_dto_list.length) {
      this.labelImageOptions = [];
      return;
    }

    ;
    var warning_label_list = gpsr_dto_list[0].gucang_draw_dto.warning_label_list;

    if (!warning_label_list || !warning_label_list.length) {
      this.labelImageOptions = [];
      return;
    }

    ;
    this.labelImageOptions = this.labelImageOptions.filter(function (item) {
      return warning_label_list.includes(item.field_code);
    });
  };

  DetailModel.prototype.created = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2];
      });
    });
  };

  __decorate([Prop({
    type: Object,
    "default": function _default() {
      return {};
    }
  })], DetailModel.prototype, "record", void 0);

  __decorate([enumData('EuroAgents/EuroAgentFileTypeEnum')], DetailModel.prototype, "euroAgentFileTypeEnum", void 0);

  __decorate([Watch('visible', {
    immediate: true
  })], DetailModel.prototype, "handleVisibleChange", null);

  DetailModel = __decorate([Component({
    components: {
      AttachmentList: AttachmentList
    }
  })], DetailModel);
  return DetailModel;
}(Vue);

export default DetailModel;